import { IElementCategory } from '../../models/element-categories.model';
import { slab } from './slab';
import { wall } from './wall';
import { column } from './column/column';
import { beam } from './beam/beam';
import { other } from './other/other';

// Will appear in order in UI
export const systemCategories: IElementCategory[] = [
  beam,
  column,
  slab,
  wall,
  other,
];
